/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ConfigDto } from '../models/config-dto';

@Injectable({
  providedIn: 'root',
})
export class GeneratedConfigService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation storeDocumentEncryptionPublicKey
   */
  static readonly StoreDocumentEncryptionPublicKeyPath = '/api/config/DocumentEncryptionPublicKey';

  /**
   * Stores a new public key for document encryption.
   *
   * NOTE: Will fail when there is already a public key set.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storeDocumentEncryptionPublicKey()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  storeDocumentEncryptionPublicKey$Response(params?: {
    'X-API-Version'?: string;
    body?: string
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, GeneratedConfigService.StoreDocumentEncryptionPublicKeyPath, 'put');
    if (params) {
      rb.header('X-API-Version', params['X-API-Version'], {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Stores a new public key for document encryption.
   *
   * NOTE: Will fail when there is already a public key set.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `storeDocumentEncryptionPublicKey$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  storeDocumentEncryptionPublicKey(params?: {
    'X-API-Version'?: string;
    body?: string
  },
  context?: HttpContext

): Observable<void> {

    return this.storeDocumentEncryptionPublicKey$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation getEncryptionKeyExportSalt
   */
  static readonly GetEncryptionKeyExportSaltPath = '/api/config/EncryptionKeyExportSalt';

  /**
   * Gets the system-wide salt for exported encryption keys.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEncryptionKeyExportSalt()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEncryptionKeyExportSalt$Response(params?: {
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, GeneratedConfigService.GetEncryptionKeyExportSaltPath, 'get');
    if (params) {
      rb.header('X-API-Version', params['X-API-Version'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * Gets the system-wide salt for exported encryption keys.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEncryptionKeyExportSalt$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEncryptionKeyExportSalt(params?: {
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<string> {

    return this.getEncryptionKeyExportSalt$Response(params,context).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation getConfig
   */
  static readonly GetConfigPath = '/api/config';

  /**
   * Gets the configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConfig()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConfig$Response(params?: {
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ConfigDto>> {

    const rb = new RequestBuilder(this.rootUrl, GeneratedConfigService.GetConfigPath, 'get');
    if (params) {
      rb.header('X-API-Version', params['X-API-Version'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ConfigDto>;
      })
    );
  }

  /**
   * Gets the configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConfig$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConfig(params?: {
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<ConfigDto> {

    return this.getConfig$Response(params,context).pipe(
      map((r: StrictHttpResponse<ConfigDto>) => r.body as ConfigDto)
    );
  }

}
